import { HINDU_OY, HINDU_VIEW_H, HINDU_VIEW_W } from "./hinduGeom.js";
import { hinduSilhouette, HinduPile } from "./HinduPile.js";
import { project } from "./hinduPose.js";
import { hinduPacketPose, hinduStepAt, type HinduStep } from "./hinduStep.js";

function Frame({ step, clipId }: { step: HinduStep; clipId: string }) {
  const restAt = project({ x: 0, y: 0, z: 0 });
  const packAt = project(hinduPacketPose(step));
  const mainN = step.hiding ? step.rest + step.packet : step.rest;
  const mainY = step.hiding ? restAt.y : restAt.y - step.restLift;
  const packet = <HinduPile layers={step.packet} x={packAt.x} y={packAt.y} />;
  const main = <HinduPile layers={mainN} x={restAt.x} y={mainY} />;
  if (!step.hiding) return <g>{main}{packet}</g>;
  return (
    <g>
      <defs>
        <clipPath id={clipId} clipPathUnits="userSpaceOnUse">
          <path
            d={`M0,0H${HINDU_VIEW_W}V${HINDU_VIEW_H}H0Z ${hinduSilhouette(restAt.x, HINDU_OY, mainN)}`}
            clipRule="evenodd"
          />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>{packet}</g>
      {main}
    </g>
  );
}

export function HinduShuffleView({ elapsed, clipId = "hindu-out" }: { elapsed: number; clipId?: string }) {
  const step = hinduStepAt(elapsed);
  if (step.done) return null;
  return (
    <svg
      className="hindu-reshuffle"
      viewBox={`0 0 ${HINDU_VIEW_W} ${HINDU_VIEW_H}`}
      aria-hidden="true"
      data-hindu-reshuffle=""
    >
      <Frame step={step} clipId={clipId} />
    </svg>
  );
}
